(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sectionnew"] && !Shopify.designMode) return;
  try {
    
(function() {

  function encabezadoToggleMenu(btn) {
    var drawer = document.getElementById('encabezado-drawer-menu');
    var overlay = document.getElementById('encabezado-overlay');
    var abierto = drawer.classList.contains('encabezado-drawer--abierto');
    if (abierto) {
      encabezadoCerrarMenu();
    } else {
      drawer.classList.add('encabezado-drawer--abierto');
      overlay.classList.add('encabezado-overlay--visible');
      drawer.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
  }

  function encabezadoCerrarMenu() {
    var drawer = document.getElementById('encabezado-drawer-menu');
    var overlay = document.getElementById('encabezado-overlay');
    var btn = document.querySelector('.encabezado-boton-menu');
    drawer.classList.remove('encabezado-drawer--abierto');
    overlay.classList.remove('encabezado-overlay--visible');
    drawer.setAttribute('aria-hidden', 'true');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function encabezadoToggleBusqueda() {
    var modal = document.getElementById('encabezado-modal-busqueda');
    var overlay = document.getElementById('encabezado-overlay');
    var abierto = modal.classList.contains('encabezado-busqueda-modal--abierto');
    if (abierto) {
      encabezadoCerrarBusqueda();
    } else {
      modal.classList.add('encabezado-busqueda-modal--abierto');
      overlay.classList.add('encabezado-overlay--visible');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var input = modal.querySelector('.encabezado-busqueda-input');
      if (input) setTimeout(function() { input.focus(); }, 350);
    }
  }

  function encabezadoCerrarBusqueda() {
    var modal = document.getElementById('encabezado-modal-busqueda');
    var overlay = document.getElementById('encabezado-overlay');
    modal.classList.remove('encabezado-busqueda-modal--abierto');
    overlay.classList.remove('encabezado-overlay--visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.encabezadoToggleMenu = encabezadoToggleMenu;
  window.encabezadoCerrarMenu = encabezadoCerrarMenu;
  window.encabezadoToggleBusqueda = encabezadoToggleBusqueda;
  window.encabezadoCerrarBusqueda = encabezadoCerrarBusqueda;

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      encabezadoCerrarMenu();
      encabezadoCerrarBusqueda();
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
